import React from "react";
import { Container, Row, Col } from "reactstrap";
import EnhancedSeverityTiles from "./EnhancedSeverityTiles";
import EnhancedVulnerabilityTable from "./EnhancedVulnerabilityTable";
import TopCVEsChart from "./TopCVEsChart";
import SeverityDistributionChart from "./AffectedAgentsList";

const pageHeadingStyle = { color: "var(--vz-body-color)" };
const toRgba = (hex, alpha) => {
  const value = hex.replace("#", "");
  const r = parseInt(value.slice(0, 2), 16);
  const g = parseInt(value.slice(2, 4), 16);
  const b = parseInt(value.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
const pageIconWrapStyle = {
  width: 32,
  height: 32,
  borderRadius: 8,
  border: `0.5px solid ${toRgba("#FF5B00", 0.30)}`,
  background: toRgba("#FF5B00", 0.08),
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};
const pageIconStyle = { color: "#FF5B00", fontSize: 18 };

const VulnerabilityManagement = () => {
  return (
    <div className="page-content">
      <Container fluid>
        {/* Page Title */}
        <Row className="mb-4">
          <Col>
            <div className="d-flex align-items-center gap-3">
              <div style={pageIconWrapStyle}>
                <i className="ri-shield-cross-line" style={pageIconStyle}></i>
              </div>
              <h4 className="mb-0" style={pageHeadingStyle}>
                Vulnerability Management
              </h4>
            </div>
          </Col>
        </Row>

        {/* Stats Tiles */}
        <Row className="mb-4">
          <EnhancedSeverityTiles />
        </Row>

        {/* Charts and Lists Row */}
        <Row className="mb-4">
          <TopCVEsChart />
          <SeverityDistributionChart />
        </Row>

        {/* Main Table */}
        <Row>
          <EnhancedVulnerabilityTable />
        </Row>
      </Container>
    </div>
  );
};

export default VulnerabilityManagement;
